import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { homePathForUser } from './homePathForUser';

export { homePathForUser };

function AuthLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#003380]" />
    </div>
  );
}

/** Requires login; optional role allowlist. */
export function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();

  if (loading) return <AuthLoading />;
  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={homePathForUser(user)} replace />;
  }

  return children;
}

/**
 * Guest-only pages (login/register/forgot/reset).
 * Logged-in users are sent to their home dashboard — not the landing page.
 */
export function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <AuthLoading />;
  if (user) return <Navigate to={homePathForUser(user)} replace />;

  return children;
}
